'use strict';
import $ from 'jquery';
import slick from 'slick-carousel';

export default class Carousel {
  constructor() {
  }

  init() {
      $(".work-slides").slick({

          // normal options...
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
          autoplay: true,
          autoplaySpeed: 5000,
          infinite: true,
          accessibility: true,
          speed: 1000,

          // the magic
          responsive: [{

              breakpoint: 992,
              settings: {
                  slidesToShow: 3,
                  arrows: false,
                  dots: false,
                  infinite: true
              }

          }, {

              breakpoint: 768,
              settings: {
                  slidesToShow: 1,
                  infinite: true
              }

          }, {

              breakpoint: 300,
              settings: "unslick" // destroys slick

          }]
      });
  }
}


// WEBPACK FOOTER //
// ./src/js/components/carousel.js